module.exports = __webpack_public_path__ + "img/icon-funding-green.49e451ea.svg";